import axios from 'axios';
import Config from '../config';
import { getObjectData } from '../services/Storage';
import refreshToken from './tokenChecker';
let apiCount = 0;

export const postRefreshToken = async (url, payload) => {
   const URL = Config.BaseUrl + url;
   return axios
      .post(URL, payload)
      .then((response) => {
         return response;
      })
      .catch((error) => {
         return error;
      });
};

export const postResponse = async (url, values) => {
   const URL = Config.BaseUrl + url;
   const header = await getHeader();
   return axios(URL, {
       method: 'POST',
       headers: header,
       data: values
   })
       .then((response) => response)
       .catch(async (error) => {
           if (error.response && error.response.status === 401) {
               return Promise.reject(error);
           } else {
               return Promise.reject(error);
           }
       });
};

export const getResponse = async (url, params, payload) => {
   const URL = Config.BaseUrl + url;
   const header = await getHeader();
   return axios(URL, {
      method: 'GET',
      headers: header,
   })
      .then((response) => response)
      .catch(async (error) => {
         if (
            error.response.status === 401 &&
            apiCount < 15 &&
            (await refreshToken())
         ) {
            return await getResponse(url, payload);
         } else return error;
      });
};

export const updateCall = async (url, payload, val) => {
   const URL = Config.BaseUrl + url;
   const header = await getHeader(val ? true : false);
   return axios(URL, {
      method: 'PUT',
      headers: header,
      data: payload,
   })
      .then((response) => response)
      .catch(async (error) => {
         if (error.response.status === 401) {
            if (await refreshToken()) return await updateCall(url, payload);
         }
         return error.response;
      });
};

export const myMultipartForm = async (url, payload) => {
   const URL = Config.BaseUrl + url;
   let token = null;
   let tokenData = await getObjectData('auth');
   if (tokenData) token = `Bearer ${tokenData.accessToken}`;
   return axios(URL, {
      method: 'PUT',
      headers: { 'Content-Type': 'multipart/form-data', Authorization: token },
      data: payload,
   })
      .then((response) => response)
      .catch(async (error) => {
         if (error.response.status === 401) {
            if (await refreshToken())
               return await myMultipartForm(url, payload);
         }
         return error.response;
      });
};

export const update = async (url, payload) => {
   const URL = Config.BaseUrl + url;
   const header = await getHeader();
   return axios(URL, {
      method: 'PATCH',
      headers: header,
      data: payload,
   })
      .then((response) => response)
      .catch(async (error) => {
         if (error.response.status === 401) {
            if (await refreshToken()) return await update(url, payload);
         }
         return error.response;
      });
};

export const deleteResponse = async (url) => {
   const URL = Config.BaseUrl + url;
   const header = await getHeader();
   return axios(URL, {
      method: 'DELETE',
      headers: header,
   })
      .then((response) => response)
      .catch(async (error) => {
         if (
            error.response.status === 401 &&
            apiCount < 15 &&
            (await refreshToken())
         ) {
            return await postResponse(url, payload);
         } else return error;
      });
   // .catch(async error => {
   //
   //    if (error.response.status == 401) {
   //       await clear();
   //       window.location = '/';
   //    }
   //    return error.response.data.errors
   // })
};

export const getResponseWithoutAuth = async (url, params) => {
   const URL = Config.BaseUrl + url;
   const header = await getHeader();
   return axios(URL, {
      method: 'GET',
      headers: header,
   })
      .then((response) => response)
      .catch(async (error) => {
         return error;
      });
};

export const postResponseFormData = async (url, payload) => {
   const URL = Config.BaseUrl + url;
   const header = await getHeader(true);
   return axios
      .post(URL, payload, {
         headers: header,
         maxContentLength: Infinity,
         maxBodyLength: Infinity,
      })
      .then((response) => response)
      .catch(async (error) => {
         if (
            error.response.status === 401 &&
            apiCount < 15 &&
            (await refreshToken())
         ) {
            return await postResponse(url, payload);
         } else return error;
      });
};

const getHeader = async (formData) => {
   let token = null;
   let tokenData = await getObjectData('auth');
   if (tokenData) token = `Bearer ${tokenData.accessToken}`;
   return {
      Accept: formData ? 'application/json' : 'application/json',
      'Content-Type': formData ? 'multipart/form-data' : 'application/json',
      Authorization: token,
   };
};

const getOtpHeader = async (formData) => {
   return {
      Accept: formData ? 'application/json' : 'application/json',
      'Content-Type': formData ? 'multipart/form-data' : 'application/json',
   };
};
